import dayjs from 'dayjs';
import { CropTypes } from '../../../services/entities/impl/blfApi/schemas/variety';
import { roundFractional } from '../ranchUtils';

export const formatCellContent = (
  value: string | number | Date,
  { maxFractionDigits }: { maxFractionDigits?: number } = {}
) => {
  if (value === null || value === undefined) {
    return '-';
    // return '—';
  }

  if (typeof value === 'number') {
    return roundFractional(value as number, maxFractionDigits);
  }
  if (value instanceof Date) {
    return dayjs(value).format('M/D/YYYY');
  }
  return value;
};

export const cropTypesToDouble = [
  CropTypes.JuiceGrapes as string,
  CropTypes.TableGrapes as string,
];
